import CheckboxGroup from "../../components/Checkbox";
import Input from "../../components/InputBox";
import { SelfSignUpFields } from "../../utils/enumSelfSignup";

const PaymentPage = ({ formData, setFormData }) => {

    const handleChange = (e) => {
        const { name, value } = e.target;
        if(name === "tenant_subscriptionModel") {
        setFormData(prev => ({ ...prev, [name]: null }));
        }else{
              setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    return (
        <div className="card_content">
            <h4>Step 6: Payment & Final Submission</h4>
            <p>This page will display payment & final submission relevant to the self-sign-up process.</p>
            <Input isRequired className={"input"} label="Subscription Plan" name="tenant_subscriptionModel" value={formData?.tenant_subscriptionModel} onChange={handleChange} />
            {/* <Input isRequired className={"input"} label="Payment Details" name="tenant_paymentDetails" value={formData?.tenant_paymentDetails} onChange={handleChange} /> */}
            <CheckboxGroup
                options={[{label: "I agree to the Terms and Conditions", value: "accepted"}]} 
                name={SelfSignUpFields.TENANT_TERMS_AND_CONDITIONS} 
                values={formData?.[SelfSignUpFields.TENANT_TERMS_AND_CONDITIONS] ? ["accepted"] : []} 
                onChange={(newValues, checked) =>
                    setFormData({ 
                        ...formData, 
                        [SelfSignUpFields.TENANT_TERMS_AND_CONDITIONS]: checked
                    })
                }
            />
        </div>
    )
}

export default PaymentPage;